import { useState } from 'react';
import { Navbar, Container, Nav, Badge } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserPermissions } from '../contexts/UserPermissionsContext';
import LoginButton from './auth/LoginButton';
import LogoutButton from './auth/LogoutButton';
import UserProfile from './auth/UserProfile';

function SinglePageNavbar() {
  const location = useLocation();
  const { isAuthenticated } = useAuth0();
  const { userPermissions, isPending, isAdmin, isViewer } = useUserPermissions();
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <Navbar
      expand="lg"
      variant="dark"
      fixed="top"
      expanded={expanded}
      onToggle={setExpanded}
      className="modern-navbar"
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={handleNavClick} className="navbar-brand-custom">
          <div className="brand-wrapper">
            <span className="brand-text">DoSS</span>
            <span className="brand-subtitle">Department of Social Services</span>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link
              as={Link}
              to="/"
              onClick={handleNavClick}
              className={location.pathname === '/' ? 'active' : ''}
            >
              Home
            </Nav.Link>

            {isAuthenticated && !isPending && (
              <>
                <Nav.Link
                  as={Link}
                  to="/search"
                  onClick={handleNavClick}
                  className={location.pathname === '/search' ? 'active' : ''}
                >
                  Search
                </Nav.Link>
                {!isViewer && (
                  <Nav.Link
                    as={Link}
                    to="/register"
                    onClick={handleNavClick}
                    className={location.pathname === '/register' ? 'active' : ''}
                  >
                    Register
                  </Nav.Link>
                )}
                <Nav.Link
                  as={Link}
                  to="/analytics/select"
                  onClick={handleNavClick}
                  className={location.pathname.startsWith('/analytics') ? 'active' : ''}
                >
                  Analytics
                </Nav.Link>
              </>
            )}

            {isAuthenticated && isAdmin && (
              <Nav.Link
                as={Link}
                to="/dashboard"
                onClick={handleNavClick}
                className={location.pathname === '/dashboard' ? 'active' : ''}
              >
                Dashboard
              </Nav.Link>
            )}
          </Nav>

          <Nav className="ms-auto align-items-lg-center">
            <div className="auth-section">
              {isAuthenticated ? (
                <div className="d-flex flex-column flex-lg-row align-items-lg-center gap-2 gap-lg-3">
                  <UserProfile />
                  {isPending && (
                    <Badge bg="warning" text="dark" className="pending-badge">
                      Pending
                    </Badge>
                  )}
                  <LogoutButton />
                </div>
              ) : (
                <LoginButton />
              )}
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default SinglePageNavbar;